import React from "react";
import V20Embed from "@/components/mock/V20Embed";
export default function Eligibility() {
  return <V20Embed view="eligibility" testid="eligibility-view" />;
}
